import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {EMPTY, Observable} from 'rxjs';
import {CompanyWizardService} from './company-wizard/company-wizard.service';
import {CompanyResponse} from '@frontend/shared-api';
import {catchError} from 'rxjs/operators';
import {APP_ROUTES} from '../../../app.routes';

@Injectable({providedIn: 'root'})
export class CompanyResolver implements Resolve<CompanyResponse> {
  private readonly companyWizardService = inject(CompanyWizardService);
  private readonly router = inject(Router);

  resolve(route: ActivatedRouteSnapshot): Observable<CompanyResponse> {
    const companyId = parseInt(route.paramMap.get('id') ?? '', 10);
    if (isNaN(companyId)) {
      this.router.navigate([APP_ROUTES.COMPANY]);
      return EMPTY;
    }
    return this.companyWizardService.getCompanyData(companyId).pipe(
      catchError((err) => {
        console.error('Failed to load company', err);
        this.router.navigate([APP_ROUTES.COMPANY]);
        return EMPTY;
      }),
    );
  }
}
